import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { resolveHeadingId } from "@/lib/scroll-to-anchor";
import { useStyledBlock, StyleControls, AdvancedStyleControls } from "./StyleControls";
import type { BlockSettingsTabProps } from "./BreakpointSwitcher";
import type { ResponsiveStyleProps } from "@/lib/craft/style-props";

type TextProps = {
  text: string;
  variant: "p" | "h2" | "h3" | "ul";
  anchorId?: string;
  className?: string;
  style?: ResponsiveStyleProps;
};

export function TextBlockSettings({ tab, breakpoint }: BlockSettingsTabProps) {
  const { props, setProp, style, updateStyle } = useStyledBlock<TextProps>();

  if (tab === "content") {
    return (
      <div className="space-y-3">
        <div className="space-y-1">
          <Label className="text-xs">Variant</Label>
          <Select
            value={props.variant ?? "p"}
            onValueChange={(v) => setProp((p) => { p.variant = v as TextProps["variant"]; })}
          >
            <SelectTrigger className="h-8 text-xs"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="p">Paragraph</SelectItem>
              <SelectItem value="h2">Heading 2</SelectItem>
              <SelectItem value="h3">Heading 3</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1">
          <Label className="text-xs">Text</Label>
          <Input
            className="h-8 text-xs"
            value={props.text ?? ""}
            onChange={(e) => setProp((p) => { p.text = e.target.value; })}
          />
        </div>
        {(props.variant === "h2" || props.variant === "h3") && (
          <div className="space-y-1">
            <Label className="text-xs">Anchor ID</Label>
            <Input
              className="h-8 font-mono text-xs"
              placeholder={resolveHeadingId(props.text ?? "")}
              value={props.anchorId ?? ""}
              onChange={(e) => setProp((p) => { p.anchorId = e.target.value; })}
            />
          </div>
        )}
      </div>
    );
  }
  if (tab === "style") {
    return (
      <StyleControls
        style={style}
        updateStyle={updateStyle}
        breakpoint={breakpoint}
        showTypography
        showBackground={false}
      />
    );
  }
  return <AdvancedStyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} />;
}
